<template>
    <section class="nodata-wrapper">
        <div class="no-notifucation-icon">
            <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <div class="nodata_message">
            <h3 >{{ $t('no-data-found','No data found!')}}</h3>
            <p v-if="isSearch">{{ $t('cant-find-any-item',"We can't find any item matching your search.")}} </p>
        </div>
    </section>
</template>

<script>
export default {
    name: "NoDataFound",
    props: {
        isSearch: {
            type: Boolean,
            default: false
        }
    }
}
</script>